<template>
  <div class="col-md-10" style="margin-top: 40px; margin-left: -40px; padding-bottom: 40px;">
    <el-form :inline="true" size="mini" :model="search" class="demo-form-inline" style="margin: 0">
      <el-form-item label="出发日期">
        <el-date-picker v-model="search.ChuFaRiQi_S" type="date" placeholder="出发日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="search.ChuFaRiQi_E" type="date" placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="search.Keyword" placeholder="出发地、到达地"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="search.OrderNo" placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item label="业务单号">
        <el-input v-model="search.YeWuDanHao" placeholder="业务单号"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="reload">查询</el-button>
      </el-form-item>
    </el-form>
    <table v-loading="showLoading" class="JY-order-one JY-order-oneB" width="100%;">
      <thead>
        <tr>
          <th style="width:32%">货物始发地及目的地</th>
          <th style="width:8%">运单数</th>
          <th style="width:10%">平台报价</th>
          <th style="width:12%">货物类型</th>
          <th style="width:12%">订单状态</th>
          <th style="width:8%">对货主评分</th>
          <th style="width:8%">对承运人评分</th>
          <th>操作</th>
          
        </tr>
      </thead>
    </table>
    <div v-for="item in items" :key="item.ID" class="JY-order-one JY-order-one-transport">
      <table width="100%;">
        <thead>
          <tr>
            <th><span style="font-weight: 600;">{{item.CreateTime}}</span><span style="margin-left:10px;">订单号：{{item.OrderNo}}</span></th>
            <th colspan="3"><span style="margin-left:10px;">业务单号：{{item.YeWuDanHao}}</span></th>
            <th colspan="3">货主：{{item.HuoZhu}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width:32%">
              <p><strong>出发地</strong><span class="jobs">{{item.ChuFaDi}}</span><br><strong>到达地</strong><span class="jobs">{{item.DaoDaDi}}</span></p>
            </td>
            <td class="taC" style="width:8%">{{item.YunDanNum}}</td>
            <td class="taC" style="width:10%">{{item.PingTaiBaoJia}}</td>
            <td class="taC" style="width:12%">{{item.GoodsType}}</td>
            <td class="taC" style="width:12%"><p>{{item.Status}}<br><strong style="color: #df0024;">{{item.OrderStatus}}</strong></p></td>
            <td class="taC" style="width:8%">{{item.Score}}</td>
            <td class="taC" style="width:8%">{{item.DriverScore}}</td>
            <td class="taC" style="border-right: 0;">
              <p>
              <a href="javascript:;" @click="openOrder(item)">订单详情</a><br>
              <a href="javascript:;" @click="openDetail(item)">运单列表</a><br>
              <a href="javascript:;" v-if="item.DriverScore==0" @click="openScore(item)">对承运人评分</a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination @current-change="loadMore" background :page-size="search.PageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="订单详情" width="80%" top="1vh" :visible.sync="dialogVisible">
      <good-detail :good="selectedGood" :images="selectedGoodImages"></good-detail>
    </el-dialog>
      <el-dialog title="运单列表" width="80%" top="1vh" :visible.sync="yunDanTableDialogVisible">
        <yundan-table v-if="yunDanTableDialogVisible" :orderNo="currentOrderNo"></yundan-table>
    </el-dialog>
    <el-dialog title="对承运人评分" width="40%" top="1vh" :visible.sync="scoreDialogVisible">
      <div class="container-fluid">
        <div class="row el-table__body JY-order-detail JY-order-detail-b">
          <div class="col-sm-12 col-md-12">
            <el-form class="el-form demo-table-expand" label-width="200px">
              <el-form-item label="服务态度（满分5分）">
                <el-input v-model="scoreForm.ysxl"></el-input>
              </el-form-item>
              <el-form-item label="装货时效（满分5分）">
                <el-input v-model="scoreForm.ysaq"></el-input>
              </el-form-item>
              <el-form-item label="卸货时效（满分5分）">
                <el-input v-model="scoreForm.fwzl"></el-input>
              </el-form-item>
              <el-form-item label="货损货差（满分5分）">
                <el-input v-model="scoreForm.khmyd"></el-input>
              </el-form-item>
              
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="createScore">确定</el-button>
              <el-button @click="scoreDialogVisible = false">取消</el-button>
            </div>
          </div>
          
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import api from "../../api";
  import goodDetail from "../../components/goodDetail";
  import yundanTable from "../../components/yundanTable";
  export default {
    components: {
      goodDetail,
      yundanTable
    },
    data() {
      return {
        selectedGood: {},
        selectedGoodImages: [],
        dialogVisible: false,
        yunDanTableDialogVisible: false,
        scoreDialogVisible: false,
        currentOrderNo: '',
        showLoading: false,
        items: [],
        total: 0,
        search: {
          PageNo: 1,
          PageSize: 20,
          YunShuStatus: "",
          ChuFaRiQi_S: "",
          ChuFaRiQi_E: "",
          Keywords: "",
          OrderNo: "",
          YeWuDanHao: "",
          OrderYunDanNo: "",
          IsEnabled:0,
        },
        scoreForm:{
          ysxl:5,
          ysaq:5,
          fwzl:5,
          khmyd:5,
        },
        idx:null,
      };
    },
    methods: {
      openDetail(order) {
        this.currentOrderNo = order.OrderNo
        this.yunDanTableDialogVisible = true
      },
      openOrder(item) {
        let _this = this;
        _this.showLoading = true;
        api.getSourceGood({id: item.ID}).then(res => {
          _this.showLoading = false;
          if (!res.data.Succeed) {
            _this.$message({
              message: res.data.Message,
              type: "error"
            });
            return
          }
          _this.dialogVisible = true;
          _this.selectedGood = res.data.Data.Data;
          if(_this.selectedGood.HuoZhu==undefined){
            _this.selectedGood.HuoZhu=''
          }
          if(_this.selectedGood.UpdateTime==undefined){
            _this.selectedGood.UpdateTime=''
          }
          if (res.data.Data.BaoJia) {
            _this.baoJia = res.data.Data.BaoJia;
            _this.baoJiaTotal = res.data.Data.BaoJia.Total;
            _this.baoJiaJson = JSON.parse(_this.baoJia.BaoJiaJson);
          } else {
            if (_this.selectedGood.BaoJiaLeiXing == '1') {
              _this.baoJiaJson = _this.selectedGood.CarList
            }
          }
          _this.selectedGoodImages = [];
            if (res.data.Data.Attachments) {
              res.data.Data.Attachments.forEach(item => {
                _this.selectedGoodImages.push(process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID);
              });
            }
          });
        },
        loadMore(n) {
          this.search.PageNo = n;
          this.loadItems();
        },
        reload() {
          this.search.PageNo = 1;
          this.loadItems();
        },
        loadItems() {
          let _this = this;
          _this.showLoading = true;
          api.searchOrders(_this.search).then(res => {
            _this.showLoading = false;
            if (res.data.Succeed) {
              _this.items = res.data.Data.Data;
              _this.total = res.data.Data.totalItemCount;
            }
          });
        },
      openScore(item){
        this.idx=item.ID
        this.scoreDialogVisible =true
      },
      createScore(){
        let score =Number(this.scoreForm.ysxl) +
                    Number(this.scoreForm.ysaq)+
                    Number(this.scoreForm.fwzl)+
                    Number(this.scoreForm.khmyd)
        this.items.forEach((item,index)=>{
          if(this.idx == item.ID) {
            this.items[index].DriverScore=(score/4).toFixed(2)
            return false
          }
        })

        this.scoreDialogVisible =false
      },
    
    
    },
    mounted() {
      this.loadItems();
    }
  };
</script>

<style>
  .JY-items-list,
  .JY-items-search {
    width: 100%;
  }
  span.el-tag {
    margin-right: 5px;
  }
  .el-table th.gutter {
    display: table-cell !important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Shipper/ShipperOrders.vue